<template>
  <div class="py-2 px-6" v-if="show">
    <label for="comment" class="block text-sm font-medium leading-6 text-secondary">Bemærkning</label>
    <div>
      <input id="comment" v-model="remark" name="comment" placeholder="Ingen bemærkning"
        class="block w-full rounded-md border-0 pb-1.5 pt-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-200 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-secondary sm:text-sm sm:leading-6 font-medium" />
    </div>
  </div>
  <div class="py-2 px-6" v-if="!show">
    <div class="text-sm text-gray-800">Der er ingen mobiliseringer på denne dag.</div>
  </div>
</template>

<script lang='ts'>
import { defineComponent, ref, watch } from 'vue'
import { useStore } from 'vuex'

export default defineComponent({
  name: 'RemarkSection',
  setup () {
    const store = useStore()
    const remark = ref('')
    const show = ref(false)
    let timeoutId: number | undefined

    watch(
      () => store.state.report.currentReport, (currentReport) => {
        remark.value = ''
        show.value = currentReport && currentReport.state !== 'FREE'
        if (currentReport && currentReport.remark) {
          remark.value = currentReport.remark
        }
      },
      { immediate: true }
    )

    watch(remark, (newVal: string) => {
      if (timeoutId) {
        clearTimeout(timeoutId)
      }

      timeoutId = setTimeout(() => {
        store.commit('report/UPDATE_REPORT', { key: 'remark', value: newVal })
      }, 300)
    })

    return { remark, show }
  }
})
</script>
